import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { addNewNotification, getNotifications } from "./actions";

export const notificationsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const initialState = notificationsEntityAdapter.getInitialState({
  count: 0,
});

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: initialState,
  reducers: {
    updateNotification: (state, action) => {
      notificationsEntityAdapter.updateOne(state, {
        id: action.payload.id,
        changes: action.payload,
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.fulfilled, (state, action) => {
        if (action?.payload?.statusCode === 200) {
          notificationsEntityAdapter.setAll(state, action.payload.data?.notificationsData || []);
        } else {
          notificationsEntityAdapter.setAll(state, []);
        }
      })
      .addCase(addNewNotification.fulfilled, (state, action) => {
        if (action.payload) {
          notificationsEntityAdapter.addOne(state, action.payload);
        }
      });
  },
});

export const { updateNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
